// extracted by css-extract-rspack-plugin
export default {"bui-TagList":"RH6vZOMUe3ozH13w","bui-Tag":"RbVv4ECvOgnU1Dwb","bui-TagRemoveButton":"l9zJlYdsd_AvoCWG","bui-TagIcon":"APxTgEybjsYQrIC6"};